export default __webpack_public_path__ + "static/media/kidneystone.4cc761ef.svg";